import { SOLAR } from "@/constants/testIds";
import { formatMinutesSigned, formatTime, type SolarResult } from "@/lib/solar";
import { EYEBROW, Stat } from "@/components/solar/ui";

function BreakdownRow({ label, value, testid }: { label: string; value: number; testid: string }) {
  return (
    <div className="flex items-baseline justify-between gap-3">
      <dt className="italic text-[#8a6f52]">{label}</dt>
      <dd data-testid={testid} className="tabular-nums text-[#5e4a35]">
        {formatMinutesSigned(value)}
      </dd>
    </div>
  );
}

function EquationOfTimeStat({ result }: { result: SolarResult }) {
  return (
    <div className="border-l border-[#d9c9ad] pl-5">
      <p className={EYEBROW}>Equation of time</p>
      <p data-testid={SOLAR.eot} className="mt-2 font-serif text-3xl tabular-nums">
        {formatMinutesSigned(result.equationOfTime)}
      </p>
      <dl className="mt-3 space-y-1 font-sans text-xs">
        <BreakdownRow label="axial tilt" value={result.obliquityComponent} testid={SOLAR.eotObliquity} />
        <BreakdownRow label="elliptical orbit" value={result.eccentricityComponent} testid={SOLAR.eotEccentricity} />
      </dl>
    </div>
  );
}

export default function FormulaStrip({ result, placeTz, tzLabel }: { result: SolarResult; placeTz: string; tzLabel: string }) {
  return (
    <section className="mb-14 grid grid-cols-1 gap-6 md:grid-cols-3">
      <EquationOfTimeStat result={result} />
      <Stat
        label="Longitude correction"
        testid={SOLAR.lonCorr}
        value={formatMinutesSigned(result.longitudeCorrection)}
        caption={`vs. standard meridian ${tzLabel}`}
      />
      <Stat
        label="Solar noon"
        testid={SOLAR.solarNoon}
        value={result.solarNoon ? formatTime(result.solarNoon, placeTz) : "—"}
        caption="when the sun crosses your meridian"
      />
    </section>
  );
}
